"use client"

import { useState } from "react"
import { Search, Plus } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { AgentDetail } from "@/components/agent-detail"
import { AuthGuard } from "@/components/auth-guard"

interface Agent {
  id: string
  name: string
  createdDate: string
  createdBy: string
  updatedDate: string
}

const mockAgents: Agent[] = [
  {
    id: "1",
    name: "Appointment booking Inbound Call",
    createdDate: "2024-12-21",
    createdBy: "Rahul",
    updatedDate: new Date().toISOString().split("T")[0],
  },
  {
    id: "2",
    name: "Noshow & Feedback Outbound Call",
    createdDate: "2024-12-21",
    createdBy: "Rahul",
    updatedDate: new Date().toISOString().split("T")[0],
  },
]

function AgentsPage() {
  const [selectedAgent, setSelectedAgent] = useState<Agent | null>(null)
  const [searchQuery, setSearchQuery] = useState("")

  const filteredAgents = mockAgents.filter((agent) => agent.name.toLowerCase().includes(searchQuery.toLowerCase()))

  return (
    <div className="flex h-screen bg-background">
      {/* Agents List - Always visible */}
      {!selectedAgent && (
        <div className="w-full border-r border-border">
          <div className="flex h-full flex-col">
            {/* Header */}
            <div className="border-b border-border px-6 py-4">
              <div className="flex items-center justify-between mb-4">
                <h1 className="text-xl font-semibold">AI Voice Agents</h1>
                <Button size="sm" className="gap-2 bg-foreground text-background hover:bg-foreground/90">
                  <Plus className="h-4 w-4" />
                  Add Agent
                </Button>
              </div>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <Input
                  placeholder="Search agents..."
                  className="pl-10"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

            {/* Agents Table */}
            <div className="flex-1 overflow-auto">
              <table className="w-full">
                <thead className="sticky top-0 bg-background border-b border-border">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground">Agent Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground">Created Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground">Created By</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground">Updated Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAgents.map((agent) => (
                    <tr
                      key={agent.id}
                      onClick={() => setSelectedAgent(agent)}
                      className="cursor-pointer border-b border-border/50 hover:bg-accent/50 transition-colors"
                    >
                      <td className="px-6 py-4 text-sm font-medium">{agent.name}</td>
                      <td className="px-6 py-4 text-sm text-muted-foreground">{agent.createdDate}</td>
                      <td className="px-6 py-4 text-sm text-muted-foreground">{agent.createdBy}</td>
                      <td className="px-6 py-4 text-sm text-muted-foreground">{agent.updatedDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {selectedAgent && (
        <div className="w-full overflow-auto">
          <AgentDetail agent={selectedAgent} onClose={() => setSelectedAgent(null)} />
        </div>
      )}
    </div>
  )
}

export default function Page() {
  return (
    <AuthGuard>
      <AgentsPage />
    </AuthGuard>
  )
}
